import { useMemo } from "react";

import { range } from "lodash";
import { useFormContext } from "react-hook-form";

import { FormSelectField } from "@covertree/ui";

import { HomeDetailsForm } from "../validatorsAndTypes/homeDetailsAndConstructionForm";
import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";

export const getConstructionYearOptions = (modelYear: number) => {
  const currentYear = new Date().getFullYear();

  const minDate = modelYear > currentYear ? currentYear : modelYear - 1;

  if (currentYear === minDate) {
    return [{ value: currentYear, label: currentYear.toString() }];
  }

  return range(currentYear, minDate).map((year) => ({
    value: year,
    label: year.toString(),
  }));
};

interface Props {
  minYear?: number;
  name?: string; // @TODO investigate why "Path" from "react-hook-form" type is not working
  label?: React.ReactNode;
  tooltip?: string;
  placeholder?: string;
  disabled?: boolean;
  fontSize?: number;
  labelFontSize?: number;
}

export function RoofConstructionYearSelect({
  minYear,
  name = "roofYearYyyy",
  label = "When was your roof constructed/last replaced?",
  tooltip = "Not sure what year the roof was constructed or replaced? You can often find this in the original inspection report, appraisal documents, and/or permits associated with your home purchase.",
  placeholder = "ex. 2010",
  disabled = false,
  fontSize,
  labelFontSize,
}: Props) {
  const { roofYearYyyy } = useNewBusinessSelector(selectBasicQuestions);

  const { control } = useFormContext<HomeDetailsForm>();

  const options = useMemo(() => {
    if (minYear) return getConstructionYearOptions(minYear);
    return [];
  }, [minYear]);

  return (
    <FormSelectField
      id="construction-year"
      fontSize={fontSize}
      labelFontSize={labelFontSize}
      dataTestId="construction-year-input"
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      name={name as any}
      label={roofYearYyyy?.label ?? label}
      options={options}
      placeholder={placeholder}
      type="number"
      tooltip={tooltip}
      control={control}
      disabled={disabled}
    />
  );
}
